<template>
  <div
    class="mask-size-cover bg-current"
    :style="{
      maskImage: `url(assets/icons/${props.icon}.svg)`,
      width: `${size}px`,
      height: `${size}px`,
      maskSize: '100%',
    }"
  ></div>
</template>

<script lang="ts" setup>
import { withDefaults } from 'vue'

const props = withDefaults(defineProps<{
  icon: string,
  size?: number,
}>(), {
  size: 20,
})
</script>

<style scoped>
.mask-size-cover {
  mask-repeat: no-repeat;
  mask-position: center;
}
</style>